import * as yup from 'yup';
import _sumBy from 'lodash/sumBy';
import _sum from 'lodash/sum';
import _get from 'lodash/get';
import { Row, RenderConfig, SelectInput, Column, EMPTY_ARRAY, TextInput, NumberInput, AsyncSelect } from 'commons-ui';
import { WEBSITE_BUCKET_DESC_MIN_LENGTH, WEBSITE_DESC_MIN_LENGTH_ERROR_MESSAGE } from '../utils/contsants';

export const FORM_FIELD_KEYS = {
	BUCKETS: 'buckets',
	WEBSITE_NAME: 'websiteName',
	DASHBOARD_NAME: 'dashBoardName',
	CONTROL_BUCKET: 'controlBucket',
	CONTROL_BUCKET_SHARE: 'controlBucketShare',
	CONTROL_BUCKET_NAME: 'controlBucketName',
	TEST_BUCKETS: 'testBuckets',
	BUCKET_SHARE: 'bucketShare',
	BUCKET_NAME: 'bucketName',
	BUCKET_DESC: 'bucketDesc',
	VERSION: 'versionNumber'
};

export const controlShareDependencyResolver = (props: any, dependencyValues: any) => {
	const { name, setValue } = props;
	const testBucketShareSum = _sum(dependencyValues);
	setValue(name, 100 - testBucketShareSum);
};

export const validationSchema = yup.object().shape({
	websiteName: yup.string().required('Website is a required field'),
	dashBoardName: yup.string().required('Dashboard is a required field'),
	controlBucket: yup.object().shape({
		share: yup
			.number()
			.min(0, 'Should be a positive value')
			.max(100, 'Can not be greater than 100')
			.required('Share is a required field'),
		versionNumber: yup.number().min(0, 'Should be a positive value').required('versionNumber is a required field'),
		description: yup
			.string()
			.min(WEBSITE_BUCKET_DESC_MIN_LENGTH, WEBSITE_DESC_MIN_LENGTH_ERROR_MESSAGE)
			.required('Description is a required field')
	}),
	testBuckets: yup
		.array()
		.of(
			yup.object().shape({
				share: yup
					.number()
					.min(0, 'Should be a positive value')
					.max(100, 'Can not be greater than 100')
					.required('Share is a required field'),
				versionNumber: yup.number().min(0, 'Should be a positive value').required('Share is a required field'),
				description: yup
					.string()
					.min(WEBSITE_BUCKET_DESC_MIN_LENGTH, WEBSITE_DESC_MIN_LENGTH_ERROR_MESSAGE)
					.required('Description is a required field')
			})
		)
		.test({
			name: 'bucketShareError',
			message: 'Sum of shares should be equal to 100',
			test: (buckets: any, testContext) => {
				const testSum = _sumBy(buckets, 'share');
				const controlBucketShare = _get(testContext, ['parent', 'controlBucket', 'share'], 0);

				return testSum + controlBucketShare === 100;
			}
		})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DASHBOARD_NAME]: new RenderConfig()
		.setName('dashBoardName')
		.setLabel('DashBoard Name')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.WEBSITE_NAME]: new RenderConfig()
		.setName('websiteName')
		.setLabel('Website Name')
		.setRenderer(SelectInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.TEST_BUCKETS]: new RenderConfig()
		.setName('testBuckets')
		.setLabel('Test Buckets')
		.setRenderProps({ isEditable: { create: true, edit: true }, isArrayField: true, required: true, isDisabled: true }),
	[FORM_FIELD_KEYS.CONTROL_BUCKET]: new RenderConfig()
		.setName('controlBucket')
		.setLabel('Control Bucket')
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true, isDisabled: true }),
	[FORM_FIELD_KEYS.BUCKET_NAME]: new RenderConfig()
		.setName('name')
		.setLabel('Bucket Name')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.BUCKET_DESC]: new RenderConfig()
		.setName('description')
		.setLabel('Bucket Description')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.VERSION]: new RenderConfig()
		.setName('versionNumber')
		.setLabel('Bucket  APK Version')
		.setRenderer(AsyncSelect)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.BUCKET_SHARE]: new RenderConfig()
		.setName('share')
		.setLabel('Bucket Percentage')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.CONTROL_BUCKET_NAME]: new RenderConfig()
		.setName('name')
		.setLabel('Bucket Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.CONTROL_BUCKET_SHARE]: new RenderConfig()
		.setName('share')
		.setLabel('Bucket Percentage')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			dependencyResolver: controlShareDependencyResolver,
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.DASHBOARD_NAME),
	new Row(FORM_FIELD_KEYS.WEBSITE_NAME),
	new Row(FORM_FIELD_KEYS.TEST_BUCKETS, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_DESC)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_SHARE)]),
		new Column([new Row(FORM_FIELD_KEYS.VERSION)])
	]),
	new Row(FORM_FIELD_KEYS.CONTROL_BUCKET, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.CONTROL_BUCKET_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_DESC)]),
		new Column([new Row(FORM_FIELD_KEYS.CONTROL_BUCKET_SHARE)]),
		new Column([new Row(FORM_FIELD_KEYS.VERSION)])
	])
];
